import {
  _30_MIN_INDIVIDUAL_90832,
  _45_MIN_INDIVIDUAL_90834,
  _60_MIN_INDIVIDUAL_90837,
  allottedTimeFactory,
  DIAGNOSTIC_INTERVIEW_90792,
  ESTABLISHED_PATIENT_OFFICE_OR_OTHER_OUTPATIENT_SERVICES_99215,
  FAMILY_THERAPY_90847,
  FAMILY_THERAPY_WO_PATIENT_90846,
  MEDICATION_MGMT_99212,
  MEDICATION_MGMT_99213,
  MEDICATION_MGMT_99214,
  OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99204,
  OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99205,
} from "@/components/Provider/ScheduleAvailability/constants";
import { eventTypeDisplayNameFactory } from "@/components/Provider/ScheduleAvailability/ActiveScheduleDetails";
import { ProviderEnum } from "@/core/constants";

const BEHAVIORAL = ProviderEnum.BEHAVIORAL;
const BEHAVIORAL_INTAKE = ProviderEnum.BEHAVIORAL_INTAKE;
const PRESCRIBE = ProviderEnum.PRESCRIBE;

export const GUIDED_SESSION_CPT_OPTIONS = [
  {
    display: `30 Minute Individual (90832) (${allottedTimeFactory(
      _30_MIN_INDIVIDUAL_90832,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: _30_MIN_INDIVIDUAL_90832,
  },
  {
    display: `45 Minute Individual (90834) (${allottedTimeFactory(
      _45_MIN_INDIVIDUAL_90834,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: _45_MIN_INDIVIDUAL_90834,
  },
  {
    display: `60 Minute Individual (90837) (${allottedTimeFactory(
      _60_MIN_INDIVIDUAL_90837,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: _60_MIN_INDIVIDUAL_90837,
  },
  {
    display: `Family Therapy w/ Patient (90847) (${allottedTimeFactory(
      FAMILY_THERAPY_90847,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: FAMILY_THERAPY_90847,
  },
  {
    display: `Family Therapy w/o Patient (90846) (${allottedTimeFactory(
      FAMILY_THERAPY_WO_PATIENT_90846,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: FAMILY_THERAPY_WO_PATIENT_90846,
  },
  {
    display: `Office or Other Outpatient Visit w/ New Patient (99204) (${allottedTimeFactory(
      OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99204,
    )} minutes)`,
    provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
    value: OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99204,
  },
  {
    display: `Office or Other Outpatient Visit w/ New Patient (99205) (${allottedTimeFactory(
      OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99205,
    )} minutes)`,
    provider_types: [BEHAVIORAL],
    value: OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99205,
  },
  {
    display: `Diagnostic Interview (90792) (${allottedTimeFactory(
      DIAGNOSTIC_INTERVIEW_90792,
    )} minutes)`,
    provider_types: [PRESCRIBE],
    value: DIAGNOSTIC_INTERVIEW_90792,
  },
  {
    display: `Medication Management (99212) (${allottedTimeFactory(
      MEDICATION_MGMT_99212,
    )} minutes)`,
    provider_types: [PRESCRIBE],
    value: MEDICATION_MGMT_99212,
  },
  {
    display: `Medication Management (99213) (${allottedTimeFactory(
      MEDICATION_MGMT_99213,
    )} minutes)`,
    provider_types: [PRESCRIBE],
    value: MEDICATION_MGMT_99213,
  },
  {
    display: `Medication Management (99214) (${allottedTimeFactory(
      MEDICATION_MGMT_99214,
    )} minutes)`,
    provider_types: [PRESCRIBE],
    value: MEDICATION_MGMT_99214,
  },
  {
    display: `${eventTypeDisplayNameFactory(
      ESTABLISHED_PATIENT_OFFICE_OR_OTHER_OUTPATIENT_SERVICES_99215,
    )}`,
    provider_types: [PRESCRIBE],
    value: ESTABLISHED_PATIENT_OFFICE_OR_OTHER_OUTPATIENT_SERVICES_99215,
  },
];

export const SUBSTANCE_ABUSE_QUESTIONS = {
  alcohol: {
    answer: null,
    label: "Alcohol Free Days",
  },
  other: {
    answer: null,
    label: "Symptom Free Days",
  },
  substances: {
    answer: null,
    label: "Substance Free Days",
  },
};
